export const buildCaseList = (
  cases,
  components,
  handleButtonClick,
  settings
) => {
  /* eslint-disable new-cap */
  return components.getCaseListItem({
    cases,
    components,
    onView: caseId => handleButtonClick("selectedData", { case_id: caseId }),
    settings
  });
};
